<template>
  <v-toolbar id="core-toolbar" flat style="background-color: transparent" v-if="isAuthenticated">
    <div class="v-toolbar-title">
      <v-toolbar-title class="hidden-lg-and-up">
        <v-btn class="default" icon @click="expandLeftMenu">
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
      </v-toolbar-title>
    </div>
    <!-- <span class="font-weight-light mb-1">{{$router.app._route.name}}</span> -->
    <v-spacer />
    <v-toolbar-items>
      <v-flex align-center layout py-2>
        <v-btn color="primary" dark tile icon to="/">
          <v-icon color="tertiary">mdi-view-dashboard</v-icon>
        </v-btn>

        <!-- <v-menu bottom left offset-y transition="slide-y-transition">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on" tile icon>
              <v-badge color="error" overlap>
                <template slot="badge">1</template>
                <v-icon color="tertiary">mdi-bell</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in items" :key="index" @click="''">
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>-->
        <v-menu bottom left offset-y transition="slide-y-transition">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on" tile text large>
              <v-icon color="tertiary">mdi-account</v-icon>
              <span class="hidden-sm-and-down">{{username}}</span>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in items" :key="index" @click="item.action">
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-flex>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
export default {
  name: "TopNavigation",
  data() {
    return {
      items: [
        {
          icon: "exit_to_app",
          text: "Odhlásiť",
          action: this.logout
        }
      ]
    };
  },
  methods: {
    expandLeftMenu: function() {
      this.$store.commit("expandLeftMenu", true);
    },
    logout: function() {
      this.$store.dispatch("logout").then(() => {
        console.log("logout");
      });
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    username() {
      return this.$store.getters.username;
    }
  }
};
</script>